import { PageBackground, PageShell, Form, LoadingCard } from "./styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { ISale } from "../../classes/interfaces";
import { getSaleDetail, cancelSale } from "../../services/orderService";
import { auth } from "../../classes/auth";
import StoreThemeProvider from "../../components/StoreThemeProvider";
import CancelSaleModal from "./components/CancelSaleModal";
import OrderHeader from "./components/OrderHeader";
import StoreInfoCard from "./components/StoreInfoCard";
import OrderSummarySection from "./components/OrderSummarySection";
import DeliveryInfoSection from "./components/DeliveryInfoSection";
import ProductsList from "./components/ProductsList";
import PaymentsList from "./components/PaymentsList";
import StatusTimeline from "./components/StatusTimeline";
import ShareButton from "./components/ShareButton";

export default function OrderPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { saleId } = useParams<{ saleId: string }>();
  const [state, setState] = React.useState({ status: "create", token: "" });
  const [sale, setSale] = React.useState<ISale>();
  const [motivo, setMotivo] = React.useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  /*const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    details: {
      display: "block",
    },
    checked: {
      color: teal[400],
      "&$checked": {
        color: teal[600],
      },
      margin: 0,
      marginLeft: 10,
      padding: 0,
    },
  }));

  const classes = useStyles();*/

  const getSale = (forcarCarregar: boolean = false) => {
    if (!sale || sale.products.length <= 0 || forcarCarregar) {
      // getSaleDetail() throws on a missing/non-200 res.data.code, so setSale is now
      // only ever reached via .then() -- this also fixes a pre-existing bug where the
      // original inline code fell through to `setSale(res.data.data)` unconditionally
      // even when res.data.code !== 200, because it was missing a `return` after that
      // branch (see docs/superpowers/specs/2026-07-14-order-modularizacao-design.md).
      getSaleDetail(saleId)
        .then(setSale)
        .catch(() => {
          setState({ status: "404", token: state.token });
        });
    }
  };

  const getAuthorization = () => {
    if (state.token === "") {
      auth().then((token) => {
        if (token !== undefined && token !== "") {
          state.status = "allowed";
          state.token = token;
          setState({ status: "allowed", token: token });
          getSale();
        }
      });
    } else {
      getSale();
    }
  };

  useEffect(() => {
    getAuthorization();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getAuthorization is redefined every render (closes over state/sale); adding it here would re-run this effect on every render instead of once on mount
  }, []);

  if (
    sale === undefined ||
    sale.products === undefined ||
    sale.products.length <= 0
  ) {
    return (
      <PageBackground>
        <PageShell>
          <LoadingCard>Carregando Meu Pedido...</LoadingCard>
        </PageShell>
      </PageBackground>
    );
  }

  return (
    <StoreThemeProvider suffix={sale.store.suffix}>
      <PageBackground>
        <PageShell>
          <CancelSaleModal
            isOpen={modalIsOpen}
            onClose={closeModal}
            motivo={motivo}
            setMotivo={setMotivo}
            onConfirm={() => {
              if (motivo === null || motivo === "") {
                toast("É necessário informar o motivo de cancelamento", {
                  type: "error",
                  autoClose: 2000,
                });
                return;
              }

              cancelSale(saleId, motivo)
                .then((data) => {
                  //console.log(data);
                  if (data === undefined || data.code === undefined) {
                    setState({ status: "404", token: state.token });
                    return;
                  }
                  if (data.code !== 200) {
                    setState({ status: data.code, token: state.token });
                    return;
                  }
                  //setSale(data.data);
                  sale.products = [];
                  setSale(sale);
                  getSale(true);
                  setState({ status: data.code, token: state.token });
                  closeModal();
                })
                .catch((error) => {
                  console.log(error);
                  toast(
                    "Impossível cancelar, pedido já confirmado. Entre em contato com o estabelecimento.",
                    {
                      type: "error",
                      autoClose: 2000,
                    }
                  );
                  sale.products = [];
                  setSale(sale);
                  getSale(true);
                  setState({ status: "500", token: state.token });
                  closeModal();
                });
            }}
          />

          <Form
            onSubmit={(ev) => {
              ev.preventDefault();
            }}
          >
            <OrderHeader
              saleId={saleId}
              document={sale.document}
              status={sale.status || ""}
              total={sale.total || 0}
              onGoHome={() => {
                if (sale.store.suffix) {
                  navigate(`/store/${sale.store.suffix}`);
                }
              }}
              showCancelButton={
                sale.status === "waiting" || sale.status === "integrated"
              }
              onOpenCancelModal={openModal}
            />

            <StoreInfoCard store={sale.store} />

            <OrderSummarySection sale={sale} />

            <DeliveryInfoSection sale={sale} />

            <ProductsList products={sale.products} />

            <PaymentsList payments={sale.payments} />

            <StatusTimeline statuses={sale.statuses} />

            <ShareButton sale={sale} pathname={pathname} />
          </Form>
        </PageShell>
      </PageBackground>
    </StoreThemeProvider>
  );
}


